export default class SearchResultsListHeaderService {
    public init(): void {
        this.initShowAllSearchResultsCategories();
    }

    private initShowAllSearchResultsCategories(): void {
        const showAllSearchResultsCategoriesButton = document.querySelector<HTMLDivElement>(".js-show-all-search-results-categories");

        if (showAllSearchResultsCategoriesButton === null) {
            return;
        }

        showAllSearchResultsCategoriesButton.addEventListener("click", () => this.showAllSearchResultsCategories(showAllSearchResultsCategoriesButton));
    }

    private showAllSearchResultsCategories(showAllSearchResultsCategoriesButton: HTMLDivElement): void {
        showAllSearchResultsCategoriesButton.classList.add("hidden");

        for (const searchResultsCategory of document.querySelectorAll<HTMLUListElement>(".js-search-results-category")) {
            if (searchResultsCategory.classList.contains("hidden")) {
                searchResultsCategory.classList.remove("hidden", "fade-out");
                searchResultsCategory.classList.add("fade-in");
            }
        }
    }
}
